import type { ResourceEndpoints } from '../core'

export const collectionsEndpoints = {
  collection: '/api/collections',
  item: (id: string) => `/api/collections/${encodeURIComponent(id)}`,
  /** The templates (files) kept in one collection: POST multipart `files`; GET lists them. */
  /** A kept file's bytes, by the file's own id (`?download=false` to view it instead of saving it). */
  download: (assetId: string) => `/api/assets/${encodeURIComponent(assetId)}/files/download`,
  assets: (id: string) => `/api/collections/${encodeURIComponent(id)}/assets`,
} satisfies ResourceEndpoints
